import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16">
      <a
        href="#top"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        className="block bg-[#2a2e3d] hover:bg-[#3a3e4d] text-white text-center py-3 text-sm transition-colors"
        data-testid="footer-back-to-top"
      >
        Back to top
      </a>

      <div className="bg-[#1a1d29] text-white">
        <div className="max-w-[1500px] mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
          <div>
            <div className="font-display text-lg font-semibold mb-4">Studio</div>
            <ul className="space-y-2 text-neutral-300">
              <li>About shopnest</li>
              <li>Careers</li>
              <li>Sustainability</li>
              <li>Journal</li>
            </ul>
          </div>
          <div>
            <div className="font-display text-lg font-semibold mb-4">Shop</div>
            <ul className="space-y-2 text-neutral-300">
              <li><Link to="/shop/women">Women</Link></li>
              <li><Link to="/shop/men">Men</Link></li>
              <li><Link to="/shop/accessories">Accessories</Link></li>
              <li><Link to="/shop">All</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-display text-lg font-semibold mb-4">Support</div>
            <ul className="space-y-2 text-neutral-300">
              <li><Link to="/orders">Your Orders</Link></li>
              <li><Link to="/addresses">Address Book</Link></li>
              <li>Shipping & Returns</li>
              <li>Help Center</li>
            </ul>
          </div>
          <div>
            <div className="font-display text-lg font-semibold mb-4">Get on the list</div>
            <p className="text-neutral-300 mb-3">Slow releases. Occasional dispatches.</p>
            <form className="flex border-b border-white/40" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-transparent py-2 text-sm outline-none placeholder:text-neutral-500"
                data-testid="newsletter-email-input"
              />
              <button className="text-[#c8532e] text-sm font-semibold" data-testid="newsletter-submit">
                Join →
              </button>
            </form>
          </div>
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-[1500px] mx-auto px-6 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-neutral-400">
            <div className="font-display text-lg text-white">shopnest<span className="text-[#c8532e]">.</span></div>
            <div>© {new Date().getFullYear()} shopnest — All rights reserved.</div>
            <div className="flex gap-4">
              <span>Terms</span>
              <span>Privacy</span>
              <span>₹ INR</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
